// extracted by mini-css-extract-plugin
export var card = "schedule-module--card--2TZ2O";
export var groupTitle = "schedule-module--group-title--3t-Yr";
export var arrowContainer = "schedule-module--arrow-container--1n9gz";
export var arrowInner = "schedule-module--arrow-inner--1-83b";
export var nextArrow = "schedule-module--next-arrow--3imM3";
export var arrow = "schedule-module--arrow--3BNyE";
export var prevArrow = "schedule-module--prev-arrow--2Lr4V";